import { render } from "./Home.vue?vue&type=template&id=33bc6a84&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=33bc6a84&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.12_vue@3.5.12_webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bc6a84"]])

export default __exports__